// extracted by mini-css-extract-plugin
export default {"houseIllustration":"TeamCreatedSuccessPage_houseIllustration__zhXRa"};